<template>
  <div class="template-container">
    <v-preview :previewData="previewData"
               @previewVisible="previewVisible"></v-preview>
    <div class="template-content">
      <div class="header-main">
        <div class="header-content">
          <h1 class="left-main">HW-25V</h1>
          <div class="right-main">
            <router-link to="/hw25v"
                         class="main-item active-item">{{$t('industry_zt25v.text1')}}</router-link>
            <router-link to="/zt25v-data"
                         class="main-item">{{$t('industry_zt25v.text2')}}</router-link>
          </div>
        </div>
      </div>
      <div class="body-main">
        <section class="section1-main section">
          <div class="text-main">
            <div class="main-title">
              <img src="/static/images/industry/hw25v/hw25v.png" style="object-fit: contain;height: 48px;"
                   alt="ZT-25V 垂起固定翼无人机">
            </div>
            <h2 class="main-subtitle">{{$t('industry_zt25v.text3')}}</h2>
            <div class="main-tab">
              <span class="tab-item">{{$t('industry_zt25v.text4')}}</span>
              <span class="tab-item">{{$t('industry_zt25v.text5')}}</span>
              <span class="tab-item">{{$t('industry_zt25v.text6')}}</span>
            </div>
          </div>
          <div class="banner-main">
            <img src="/static/images/industry/zt25v/section1_plane.png"
                 alt="更强的性能">
          </div>
        </section>
        <section class="section2-main section">
          <div class="main-content">
            <span class="arrow-bottom"></span>
            <h2 class="main-title">{{$t('industry_zt25v.text7')}}</h2>
            <img class="main-img"
                 src="/static/images/industry/zt25v/section2_plane.png"
                 alt="ZT-25V 垂起固定翼无人机">
            <div class="main-text">
              <div class="main-item">
                <img class="item-img"
                     src="/static/images/industry/zt25v/section2_text1.png"
                     alt="4小时">
                <p class="item-text">{{$t('industry_zt25v.text8')}}</p>
              </div>
              <div class="main-item">
                <img class="item-img"
                     src="/static/images/industry/zt25v/section2_text2.png"
                     alt="50100KM">
                <p class="item-text">{{$t('industry_zt25v.text9')}}</p>
              </div>
              <div class="main-item">
                <img class="item-img"
                     src="/static/images/industry/zt25v/section2_text3.png"
                     alt="10KG">
                <p class="item-text">{{$t('industry_zt25v.text10')}}</p>
              </div>
            </div>
          </div>
        </section>
        <section class="section3-main section">
          <div class="text-main">
            <h2 class="main-title">{{$t('industry_zt25v.text11')}}</h2>
            <h3 class="main-subtitle"><span class="font-bolder">{{$t('industry_zt25v.text12')}}</span>{{$t('industry_zt25v.text13')}}</h3>
            <h3 class="main-subtitle"><span class="font-bolder">{{$t('industry_zt25v.text14')}}</span>{{$t('industry_zt25v.text15')}}</h3>
          </div>
          <img class="main-img"
               src="/static/images/industry/zt25v/section3_plane.png"
               alt="ZT-25V 垂起固定翼无人机">
        </section>
        <section class="section4-main section">
          <h2 class="main-title">{{$t('industry_zt25v.text16')}}</h2>
          <div class="main-text">
            <div class="main-item">
              <img class="item-img"
                   src="/static/images/industry/zt25v/section4_text1.png"
                   alt="双天线差分定向技术">
              <span class="item-text">{{$t('industry_zt25v.text17')}}</span>
            </div>
            <div class="main-item">
              <img class="item-img"
                   src="/static/images/industry/zt25v/section4_text2.png"
                   alt="高度集成的“四合一”航电系统">
              <span class="item-text">{{$t('industry_zt25v.text18')}}</span>
            </div>
            <div class="main-item">
              <img class="item-img"
                   src="/static/images/industry/zt25v/section4_text3.png"
                   alt="更安全的三余度安全飞控">
              <span class="item-text">{{$t('industry_zt25v.text19')}}</span>
            </div>
          </div>
        </section>
        <section class="section5-main section">
          <h2 class="main-title">{{$t('industry_zt25v.text20')}}</h2>
          <div class="main-content"
               ref="sectionScroll">
            <div class="content-left">
              <div class="left-item"
                   v-for="(item, index) in $t('industry_zt25v.listData')"
                   :key="index">
                <img v-if="item.img"
                     :src="item.img"
                     :alt="item.alt">
              </div>
            </div>
            <div class="content-right">
              <div class="right-item"
                   v-for="(item, index) in $t('industry_zt25v.listData')"
                   :key="index"
                   :class="index === idx ? 'opacity-item-active' : 'opacity-item'">
                <div class="item-main">
                  <div class="text-main">
                    <div class="item-text-en">
                      <span class="item-left-circle"></span>
                      <span class="item-right-en">HOVER WING</span>
                    </div>
                    <div class="item-text-title">{{ item.title }}</div>
                    <div class="item-text-desc">{{ item.desc }}</div>
                  </div>
                  <div v-if="item.video.length > 0"
                       class="video-main">
                    <div class="main-item"
                         v-for="(v, i) in item.video"
                         :key="i"
                         @click="showVideoAndPlay(v)">
                      <img src="/static/images/industry/zt25v/play_icon.png"
                           alt="播放按钮">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="fixed"
               class="content-fixed">
            <img :src="fixedImage.url"
                 :alt="fixedImage.alt">
          </div>
        </section>
        <section class="section6-main section">
          <div class="main-text">
            <div class="item-text-en">
              <span class="item-left-circle"></span>
              <span class="item-right-en">HOVER WING</span>
            </div>
            <div class="main-title">{{$t('industry_zt25v.text21')}}</div>
            <div class="main-desc">
              <div class="item-desc" style="height: auto;">{{$t('industry_zt25v.text22')}}</div>
              <!-- <router-link class="router-btn"
                           to="/admin">查看详情</router-link> -->
            </div>
          </div>
          <div class="main-img">
            <img src="/static/images/industry/zt25v/section6_plane.png"
                 alt="远度云巡系统">
          </div>
        </section>
        <section class="section7-main section">
          <div class="main-text">
            <h2 class="main-title">{{$t('industry_zt25v.text23')}}</h2>
            <p class="main-desc">{{$t('industry_zt25v.text24')}}</p>
            <p class="main-desc">{{$t('industry_zt25v.text25')}}</p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Preview from "@/components/preview/";
export default {
  name: "ZT25v",
  metaInfo: {
    title: 'TUSUAV 灵隼 HW-25V | 纯电动长航时垂直起降固定翼无人机',
    meta: [
      { name: "keywords", content: "TUSUAV，远度，远度科技，远度互联，远度互联科技，远度官网，灵隼，HW-25V" },
      { name: "description", content: "HW-25V电动垂直起降固定翼无人机，全天候飞行能力，巡航抗风7级，小雨长时间飞行，中雨单次≥3小时，大雨单次≥1小时，双天线差分定向技术，高度集成的“四合一”航电系统，更安全的三余度安全飞控。" }
    ]
  },
  data () {
    return {
      previewData: {
        visible: false,
        type: "",
        src: ""
      },
      offsetTop: 3652,
      fixed: false,
      idx: 0,
      url: "",
      fixedImage: {},
      
    };
  },
  created () { },
  mounted () {
    window.addEventListener("scroll", () => { this.getDomScrollTop(); });
  },
  methods: {
    getDomScrollTop () {
      if (this.$refs.sectionScroll) this.offsetTop = this.$refs.sectionScroll.getBoundingClientRect().top;
      if (this.offsetTop <= 0 && this.offsetTop >= -2500) {
        let count = parseInt((Math.abs(this.offsetTop) + 250) / 500);
        let altArr = ["抗诱骗/干扰", "DSM-CAS 智能防撞系统", "AR数据叠加", "视频引导降落", "动平台起降", "空中中继"];
        this.fixedImage.alt = altArr[count];
        this.idx = count++;
        // this.url = "/static/images/industry/zt25v/section5_plane" + count++ + ".png";
        this.fixedImage.url = "/static/images/industry/zt25v/section5_plane" + count++ + ".png";
        if(this.$i18n.locale != "zh_CN"&& this.idx==4){
          this.fixedImage.url = "/static/images/industry/zt25v/section5_plane5_1.png";
        }
        this.fixed = true;
      } else this.fixed = false;
    },
    showVideoAndPlay (v) {
      this.$set(this.previewData, "visible", true);
      this.$set(this.previewData, "type", "1");
      this.$set(this.previewData, "src", v);
    },
    previewVisible (v) {
      this.previewData.visible = v.visible;
    }
  },
  components: {
    "v-preview": Preview
  }
};
</script>

<style lang="stylus" scoped>
.template-container {
  .template-content {
    background: #000;
    min-width: 1280px;
    margin: 0 auto;

    .header-main {
      height: 66px;
      border-bottom: 1px solid #333;

      .header-content {
        max-width: 1280px;
        margin: 0 auto;
        position: relative;

        .left-main {
          padding-left: 48px;
          line-height: 66px;
          font-size: 14px;
          color: #fff;
        }

        .right-main {
          height: 100%;
          position: absolute;
          top: 0;
          right: 0;

          .main-item {
            padding: 0 48px;
            line-height: 66px;
            color: #666;
            font-size: 14px;
            cursor: pointer;
          }

          .active-item {
            color: #fff;
          }
        }
      }
    }

    .body-main {
      min-width: 1280px;
      margin: 0 auto;

      .section1-main {
        height: 820px;
        background: url('/static/images/industry/zt25v/section1_bg.png') no-repeat center center;
        background-size: cover;

        .text-main {
          padding-top: 84px;
          padding-bottom: 66px;
          text-align: center;

          .main-title {
            height: 48px;
          }

          .main-subtitle {
            font-size: 24px;
            padding-top: 13px;
            padding-bottom: 40px;
            color: #fff;
          }

          .main-tab {
            width: 360px;
            margin: 0 auto;
            display: flex;
            justify-content: center;

            .tab-item {
              margin: 0 10px;
              padding: 5px 13px;
              border-radius: 6px;
              border: 1px solid #979797;
              color: #999;
            }
          }
        }

        .banner-main {
          text-align: center;

          img {
            width: 85%;
            max-width: 1563px;
            max-height: 278px;
          }
        }
      }

      .section2-main {
        height: 880px;
        background: url('/static/images/industry/zt25v/section2_bg.png') no-repeat center center;
        background-size: cover;

        .main-content {
          text-align: center;
          position: relative;

          .arrow-bottom {
            position: absolute;
            top: 37px;
            left: 50%;
            margin-left: -5px;
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 10px solid #D8D8D8;
            opacity: 0.8;
          }

          .main-title {
            font-size: 66px;
            line-height: 92px;
            color: #fff;
            padding-top: 88px;
            padding-bottom: 20px;
          }

          .main-img {
            // width: 100%;
            max-height: 390px;
          }

          .main-text {
            width: 950px;
            margin: 30px auto;
            display: flex;
            justify-content: center;

            .main-item {
              padding: 0 20px;

              .item-img {
                height: 76px;
              }

              .item-text {
                font-size: 24px;
                font-family: PingFangTC-Regular, PingFangTC;
                font-weight: 400;
                color: #999999;
                line-height: 32px;
                text-align: left;
              }
            }
          }
        }
      }

      .section3-main {
        height: 960px;
        background: url('/static/images/industry/zt25v/section3_bg.png') no-repeat center center;
        background-size: cover;
        text-align: center;

        .text-main {
          padding-top: 84px;
          text-align: center;

          .main-title {
            padding-bottom: 56px;
            font-size: 66px;
            line-height: 92px;
            color: #fff;
          }

          .main-subtitle {
            font-size: 20px;
            padding-bottom: 16px;
            color: #fff;
            line-height: 20px;

            .font-bolder {
              font-size: 24px;
              font-weight: 600;
            }
          }
        }

        .main-img {
          width: 100%;
          max-height: 625px;
        }
      }

      .section4-main {
        height: 860px;
        background: url('/static/images/industry/zt25v/section4_bg.png'), url('/static/images/industry/zt25v/section4_bg2.png');
        background-position: center bottom, center bottom;
        background-repeat: no-repeat;
        background-size: cover;
        text-align: center;

        .main-title {
          font-size: 66px;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 92px;
          padding-top: 50px;
        }

        .main-text {
          width: 1280px;
          margin: 30px auto;
          display: flex;
          justify-content: center;

          .main-item {
            padding: 0 20px;

            .item-img {
              height: 55px;
              vertical-align: top;
            }

            .item-text {
              padding-left: 20px;
              font-size: 24px;
              font-weight: 600;
              color: #fff;
              line-height: 55px;
              text-align: left;
            }
          }
        }
      }

      .section5-main {
        width: 100%;
        height: auto;
        background: linear-gradient(180deg, #222222 0%, #080808 4%, #111111 100%);

        .main-title {
          font-size: 66px;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 92px;
          padding-top: 50px;
          text-align: center;
          // border-bottom: 1px solid red;
        }

        .content-fixed {
          position: fixed;
          height: 100vh;
          width: 50vw;
          top: 0;
          left: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #000;

          img {
            width: 100%;
            border-right: 1px solid #333;
          }
        }

        .main-content {
          display: flex;

          .content-left {
            width: 50vw;

            .left-item {
              width: 100%;
              height: 500px;
              padding-left: 62px;
              box-sizing: border-box;
              display: flex;
              justify-content: center;
              align-items: center;

              // border-bottom: 1px solid #fff;
              &:first-child {
                margin-top: 25vh;
              }

              &:last-child {
                margin-bottom: 25vh;
              }

              &:nth-child(2), &:nth-child(5) {
                img {
                  visibility: hidden;
                }
              }
            }

            img {
              width: 100%;
            }
          }

          .content-right {
            width: 50vw;

            .right-item {
              width: 100%;
              height: 500px;
              padding-left: 62px;
              box-sizing: border-box;
              display: flex;
              justify-content: center;
              align-items: center;

              // border-bottom: 1px solid #fff;
              &:first-child {
                margin-top: 25vh;
              }

              &:last-child {
                margin-bottom: 25vh;
              }

              .item-main {
                width: 100%;

                .text-main {
                  .item-text-en {
                    color: #fff;

                    .item-left-circle {
                      display: inline-block;
                      width: 8px;
                      height: 8px;
                      border-radius: 8px;
                      border: 1px solid #007BE7;
                      vertical-align: top;
                    }

                    .item-right-en {
                      display: inline-block;
                      font-size: 12px;
                      padding-left: 10px;
                      color: #007BE7;
                      letter-spacing: 0;
                      vertical-align: top;
                    }
                  }

                  .item-text-title {
                    font-size: 66px;
                    line-height: 92px;
                    padding-top: 5px;
                    padding-bottom: 20px;
                    color: #FFFFFF;
                  }

                  .item-text-desc {
                    max-width: 578px;
                    font-size: 22px;
                    line-height: 30px;
                    color: #999;
                  }
                }
              }

              .video-main {
                display: flex;
                margin-top: 20px;

                .main-item {
                  width: 140px;
                  height: 80px;
                  background: #000000;
                  border: 1px solid #2E2E2E;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-right: 20px;
                  cursor: pointer;

                  img {
                    width: 38px;
                  }
                }
              }
            }
          }

          .opacity-item {
            opacity: 0.2;
            transition: all 0.3s;
          }

          .opacity-item-active {
            opacity: 1;
            transition: all 0.3s;
          }
        }
      }

      .section6-main {
        height: 960px;
        max-width: 1200px;
        margin: 0 auto;

        .main-text {
          padding: 30px 0;

          .item-text-en {
            color: #fff;

            .item-left-circle {
              display: inline-block;
              width: 8px;
              height: 8px;
              border-radius: 8px;
              border: 1px solid #007BE7;
              vertical-align: top;
            }

            .item-right-en {
              display: inline-block;
              font-size: 12px;
              padding-left: 10px;
              color: #007BE7;
              letter-spacing: 0;
              vertical-align: top;
            }
          }

          .main-title {
            width: 300px;
            font-size: 32px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 50px;
            border-bottom: 2px solid #D8D8D8;
            padding-top: 10px;
            margin-bottom: 92px;
          }

          .main-desc {
            position: relative;

            .item-desc {
              width: 1020px;
              height: 66px;
              font-size: 24px;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 32px;
            }

            .router-btn {
              width: 100px;
              height: 32px;
              border-radius: 4px;
              border: 1px solid #FFFFFF;
              box-sizing: border-box;
              color: #fff;
              position: absolute;
              right: 0;
              top: 0;
              font-size: 18px;
              text-align: center;
              line-height: 32px;
            }
          }
        }

        .main-img {
          text-align: center;

          img {
            max-height: 540px;
          }
        }
      }

      .section7-main {
        height: 700px;
        background: url('/static/images/industry/zt25v/section7_bg.png') no-repeat center center;
        background-size: cover;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;

        .main-text {
          .main-title {
            font-size: 66px;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 92px;
            margin-bottom: 40px;
          }

          .main-desc {
            font-size: 24px;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 40px;
          }
        }
      }
    }
  }
}

@media all and (max-width: 768px) {
  .template-container {
    .template-content {
      min-width: 100%;

      .header-main {
        .header-content {
          max-width: 100%;

          .right-main {
            right: 36px;

            .main-item {
              padding: 0 12px;
            }
          }
        }
      }

      .body-main {
        min-width: 100%;

        .section1-main {
          height: 410px;
          background: url('/static/images/industry/zt25v/section1_bg.png') no-repeat center bottom;
          background-size: contain;

          .banner-main {
            img {
              width: 100%;
              max-width: 1563px;
              max-height: 278px;
            }
          }
        }

        .section2-main {
          height: auto;
          background: none;

          .main-content {
            .arrow-bottom {
              display: none;
            }

            .main-title {
              font-size: 36px;
              line-height: 40px;
              padding-top: 40px;
              padding-bottom: 80px;
            }

            .main-img {
              width: 100%;
            }

            .main-text {
              width: 100%;
              margin: 30px auto;
              display: flex;
              flex-direction: column;
              justify-content: center;

              .main-item {
                padding: 20px;

                .item-img {
                  display: inline-block;
                  height: 76px;
                }

                .item-text {
                  display: inline-block;
                  font-size: 24px;
                  font-weight: 400;
                  color: #999999;
                  line-height: 32px;
                }

                &:nth-child(2) {
                  .item-text {
                    width: 100%;
                    text-align: right;
                  }
                }
              }
            }
          }
        }

        .section3-main {
          height: auto;

          .text-main {
            padding: 40px 20px 0 20px;
            text-align: center;

            .main-title {
              padding-bottom: 40px;
              font-size: 36px;
              line-height: 40px;
            }

            .main-subtitle {
              font-size: 16px;
              padding-bottom: 16px;
              line-height: 24px;

              .font-bolder {
                font-size: 24px;
              }
            }
          }

          .main-img {
            width: 100%;
            max-height: 625px;
          }
        }

        .section4-main {
          height: 400px;
          background: url('/static/images/industry/zt25v/section4_bg.png') no-repeat center bottom;
          background-size: contain;
          text-align: center;

          .main-title {
            font-size: 36px;
            line-height: 40px;
            padding-top: 40px;
          }

          .main-text {
            width: 100%;
            margin: 40px auto;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .main-item {
              padding: 0 20px;
              margin: 10px 0;
              text-align: left;

              .item-img {
                height: 40px;
                vertical-align: top;
              }

              .item-text {
                padding-left: 10px;
                font-size: 20px;
                font-weight: 600;
                color: #fff;
                line-height: 40px;
                text-align: left;
                white-space: nowrap;
              }
            }
          }
        }

        .section5-main {
          width: 100%;
          height: auto;

          .main-title {
            font-size: 36px;
            line-height: 40px;
            padding-top: 40px;
          }

          .content-fixed {
            display: none;
          }

          .main-content {
            display: flex;

            .content-left {
              width: 50%;
              min-width: 50%;

              .left-item {
                width: 100%;
                height: 300px;
                padding-left: 0;

                &:first-child {
                  margin-top: 0;
                }

                &:last-child {
                  margin-bottom: 0;
                }

                &:nth-child(2), &:nth-child(5) {
                  img {
                    visibility: visible;
                  }
                }
              }

              img {
                width: 100%;
              }
            }

            .content-right {
              width: 50%;

              .right-item {
                width: 100%;
                height: 300px;
                padding-left: 10px;
                opacity: 1;

                &:first-child {
                  margin-top: 0;
                }

                &:last-child {
                  margin-bottom: 0;
                }

                .item-main {
                  width: 100%;
                  padding-right: 20px;

                  .text-main {
                    .item-text-title {
                      font-size: 20px;
                      line-height: 30px;
                      padding-top: 5px;
                      padding-bottom: 10px;
                    }

                    .item-text-desc {
                      max-width: 100%;
                      font-size: 12px;
                      line-height: 16px;
                    }
                  }

                  .video-main {
                    display: none;
                  }
                }
              }
            }
          }
        }

        .section6-main {
          height: auto;
          max-width: calc(100% - 40px);
          margin: 0 auto;

          .main-text {
            padding: 0;

            .main-title {
              margin-bottom: 20px;
            }

            .main-desc {
              position: relative;

              .item-desc {
                width: 100%;
                height: auto;
                font-size: 16px;
                line-height: 24px;
              }

              .router-btn {
                width: 80px;
                height: 24px;
                right: 5px;
                top: unset;
                bottom: 0;
                font-size: 12px;
                text-align: center;
                line-height: 24px;
              }
            }
          }

          .main-img {
            margin: 20px 0;
            text-align: center;

            img {
              width: 100%;
              max-height: 540px;
            }
          }
        }

        .section7-main {
          height: 300px;

          .main-text {
            padding: 0 20px;

            .main-title {
              font-size: 36px;
              line-height: 40px;
              margin-bottom: 40px;
            }

            .main-desc {
              font-size: 16px;
              line-height: 22px;
            }
          }
        }
      }
    }
  }
}

.section {
  // border-top: 1px solid red;
}
</style>



// WEBPACK FOOTER //
// src/views/industry/zt25v.vue